<template>
  <div class="c-about product" :class="[componentClasses]">
    <main-menu />
    <article-detail :data="ArticleData"></article-detail>
    <footer-container></footer-container>
  </div>
</template>

<script>
import MainMenu from '@/components/MainMenu'
import ArticleDetail from '@/components/ArticleDetail'
import FooterContainer from '@/components/FooterContainer'

let topPosition = 0

export default {
  data () {
    return {
      componentClasses: [],
      article: {}
    }
  },
  methods: {
    addCompClass (name) {
      this.componentClasses.push(name)
    }
  },
  computed: {
    ArticleData () {
      let data = {}
      const dataId = parseInt(this.$route.params.id, 10)
      this.addCompClass('loaded')
      if (this.$store.state.ProductArticle.articles !== undefined) {
        data = this.$store.state.ProductArticle.articles.find(post => (post.id === dataId))
        if (data.primaryColor === 'ホワイト') {
          this.addCompClass('primary-white')
        } else {
          this.addCompClass('primary-black')
        }
      }
      return data
    }
  },
  components: {
    MainMenu,
    ArticleDetail,
    FooterContainer
  },
  beforeRouteLeave (to, from, next) {
    topPosition = document.documentElement.scrollTop
    document.getElementsByClassName('c-about')[0].style.position = 'fixed'
    document.getElementsByClassName('c-about')[0].style.top = -topPosition + 'px'
    // console.log('H-beforeRouteLeave: ', this)
    next()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Detail.vue